import { CancellationEndpoint } from '@acorn-portal/shared/src/pages/cancellation/types';

export const postTakeUpSteps: readonly CancellationEndpoint[] = ['success'];

/**
 * Validate if the current step is accessible, in relation to the user's take-up status
 * @param currentStep - The current step in the cancellation process
 * @param takenUp - Whether the user has taken up the policy
 * @returns Whether the journey is complete
 */
export const validateJourneyCompletion = (currentStep: CancellationEndpoint | undefined, takenUp: boolean) => {
	// If there isn't a current step, they're attempting access from an invalid state
	if (!currentStep) return false;
	// Block navigation to data capture pages post-takeup
	if (takenUp) return postTakeUpSteps.includes(currentStep);
	// Block navigation to post take up pages pre-takeup
	return !postTakeUpSteps.includes(currentStep);
};
